import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import { Notify, Dialog } from 'vant'
import vueTouch from "vue-plugin-touch"
import touch from 'vue-directive-touch'
import VueI18n from 'vue-i18n'
import 'lib-flexible'
import 'vant/lib/index.css';
import VueClipboard from 'vue-clipboard2'
import vueEsign from 'vue-esign'
import VModal from 'vue-js-modal'
import { Popup } from 'vant';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import locale from 'element-ui/lib/locale/lang/pt-br.js';
import './store'
import axios from 'axios'
import VueLazyload from 'vue-lazyload';
// 新增：语言初始化函数
const initializeLanguage = async () => {
    // 尝试从本地获取缓存
    const savedLang = localStorage.getItem("X-language");
    if (savedLang) {
        console.log("Using saved language:", savedLang);
        return savedLang;
    }

    try {
        // 请求后台获取默认语言
        console.log("Fetching default language from backend...");
        const response = await axios.get("https://api.hermes-game.com" + "/api/platform/lang");
        let defaultLang = "";
        response.data.data.language.forEach(item => {
            if (item.is_default == 1) {
                defaultLang = item.name
            }
        })
        // 存储到localStorage
        localStorage.setItem("X-language", defaultLang);
        return defaultLang;
    } catch (error) {
        console.error("Failed to initialize language:", error);
        // 使用默认语言
        localStorage.setItem("X-language", "pt");
        return "pt";
    }
};

// 异步启动应用
async function launchApp() {
    // 等待语言初始化完成
    const lang = await initializeLanguage();
    Vue.use(Popup);
    Vue.use(Notify).use(Dialog).use(vueTouch).use(touch).use(VueI18n).use(VueClipboard).use(vueEsign).use(VModal);
    Vue.use(ElementUI, { locale });

    // 确保在语言初始化后创建i18n实例
    const i18n = new VueI18n({
        locale: lang,
        messages: {
            'pt': require('./assets/languages/pt_br.json'),
            'en': require('./assets/languages/en_US.json'),
            'zh': require('./assets/languages/zh_cn.json'),
            'spa': require('./assets/languages/spa_spa.json'),
        }
    });

    Vue.use(VueLazyload, {
        preLoad: 1.3,
        loading: require('/src/assets/images/common/777.png'),
        attempt: 1
    });

    Vue.config.productionTip = false;

    window.vm = new Vue({
        beforeCreate() {
            // 尽量早地执行挂载全局事件总线对象的操作
            Vue.prototype.$bus = this;
        },
        router,
        i18n,
        store,
        render: h => h(App)
    }).$mount('#app');
}

// 启动应用
launchApp().catch(error => {
    console.error("Application failed to start:", error);
    // 可以添加用户友好的错误提示
    document.getElementById('app').innerHTML = `
    <div style="text-align:center;padding:50px;">
      <h2>Application failed to start</h2>
      <p>${error.message}</p>
      <p>Please try refreshing the page or contact support.</p>
    </div>
  `;
});

// 注册Service Worker实现PWA功能
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
            .then((registration) => {
                console.log('Service Worker 注册成功:', registration.scope);
                
                // 检查是否有新的Service Worker正在等待
                if (registration.waiting) {
                    console.log('Service Worker 等待激活');
                }

                // 监听Service Worker更新
                registration.addEventListener('updatefound', () => {
                    console.log('发现新的Service Worker');
                    const newWorker = registration.installing;
                    newWorker.addEventListener('statechange', () => {
                        if (newWorker.state === 'installed') {
                            if (navigator.serviceWorker.controller) {
                                console.log('新内容可用，将在下次访问时更新');
                            } else {
                                console.log('内容已缓存，现在可以离线使用');
                            }
                        }
                    });
                });
            })
            .catch((error) => {
                console.log('Service Worker 注册失败:', error);
            });
    });
}

// PWA安装提示
window.addEventListener('beforeinstallprompt', (e) => {
    console.log('PWA安装提示触发');
    // 阻止默认的安装提示
    e.preventDefault();
    // 保存事件到全局变量，供其他组件使用
    window.deferredPrompt = e;
    // 触发自定义安装提示
    window.dispatchEvent(new CustomEvent('pwa-install-available'));
});

// 监听应用安装成功事件
window.addEventListener('appinstalled', () => {
    console.log('PWA已成功安装');
    window.deferredPrompt = null;
    window.dispatchEvent(new CustomEvent('pwa-install-success'));
});